// extracted by mini-css-extract-plugin
module.exports = {"menuHolder":"Menu_menuHolder__COLiu"};